module.exports = __webpack_public_path__ + "static/media/img-app-setting-new-hires@3x.e7616382.png";